import { createAsyncThunk } from "@reduxjs/toolkit";
import { supplierResponsesAllService } from "@/shared/services/api/supplier-responses-all-service";
import {
  ISpecificationSupplierProductsRequest,
  ISupplierResponsesAllRequest,
} from "@/shared/services/interface/requests/ISupplierResponsesAllRequest";

export const getSupplierResponsesAllThunk = createAsyncThunk(
  "supplierResponsesAll/getSupplierResponsesAll",
  async (request: ISupplierResponsesAllRequest, { rejectWithValue }) => {
    try {
      const response = await supplierResponsesAllService.getSupplierResponsesAll(
        request
      );
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Bir hata oluştu");
    }
  }
);

export const getSpecificationSupplierProductsThunk = createAsyncThunk(
  "supplierResponsesAll/getSpecificationSupplierProducts",
  async (
    request: ISpecificationSupplierProductsRequest,
    { rejectWithValue }
  ) => {
    try {
      const response =
        await supplierResponsesAllService.getSpecificationProducts(request);

      return {
        specificationId: request.specificationId,
        response,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Bir hata oluştu");
    }
  }
);

